<div
  #box
  class="tw:typography-labels-2 tw:flex tw:cursor-pointer tw:items-center tw:justify-center tw:gap-2.5 tw:border tw:px-[15px] tw:outline-none tw:transition-colors tw:duration-200"
  [class]="classes()"
>
  <fr8bot-ui-icon #icon [name]="iconName()" [size]="16" />
  <span #label class="tw:min-w-0 tw:truncate">
    <ng-content></ng-content>
  </span>
</div>
